import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import {
  Box,
  Button,
  MenuItem,
  Select,
  Stack,
  Tooltip,
  Typography
} from "@mui/material";
import DateRangePickerComponent from "../../components/date/DateRangePickerComponent";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { io } from "socket.io-client";
import CommonModel from "../../components/dialog/Common";
import useDebounce from "../../hooks/use.debounce";
import { getFormatedDate } from "../../utils/common";
import { BASE_URL, CustomSearchInput, FORM_SELECTFIELD_STYLES, PLAN_STATUS, SOCKET_EVENT, START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT, TABLE_BODY_ROW_MUI_STYLES, TABLE_HEADER_ROW_MUI_STYLES } from "../../utils/constant";
import { endpoints } from "../../utils/endpoints";
import { getAllBrandForDropDown } from "../brands/action";
import { getAllSubscriptions } from "../subscriptions/action";
import { updateSubscription } from "../subscriptions/subscriptionSlice";
import { deleteCompany, getAllCompanyforListing, getCompanyCSVDowanload } from "./action";
import { resetCompany, updateCompany } from "./companySlice";
import CustomPagination from "../../utils/CustomPagination";
function EnhancedTableHead(props) {
  const { order, orderBy } = props;


  const headCells = [

    {
      id: "name",
      numeric: false,
      disablePadding: true,
      label: "Company Name",
      type: "",
    },
    {
      id: "contact_person",
      numeric: false,
      disablePadding: true,
      label: "Contact Person",
      type: "",
    },
    {
      id: "comp_runing",
      numeric: false,
      disablePadding: true,
      label: "Campaigns Running",
      type: "",
    },
    {
      id: "last_comp_date",
      numeric: false,
      disablePadding: true,
      label: "Last Campaign Date",
      type: "",
    },

    {
      id: "subs_plan",
      numeric: false,
      disablePadding: true,
      label: "Subscription Plan",
      type: "",
    },
    {
      id: "plan_status",
      numeric: false,
      disablePadding: true,
      label: "Plan Status",
      type: "",
    },
    {
      id: "ren_date",
      numeric: false,
      disablePadding: true,
      label: "Renewal Date",
      type: "",
    },
    {
      id: "action",
      numeric: false,
      disablePadding: true,
      label: "Action",
      type: "",
    },
  ];
  return (
    <TableHead className="hideActionSort">
      <TableRow sx={TABLE_HEADER_ROW_MUI_STYLES}>
        {headCells.map((headCell) => {
          return (
            <TableCell
              key={headCell?.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}>
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                IconComponent={() => null}>
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}


const socket = io(BASE_URL + endpoints.ims, {
  path: '/stream',
  transports: ['websocket']
});
export default function Companies() {
  const navigate = useNavigate();
  const states = useSelector((state) => state.app);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [open, setOpen] = useState(false);

  const [id, setId] = useState(0);
  const tableRef = useRef();
  const dispatch = useDispatch();
  const {
    limit,
    page,
    sort_key,
    totalPages,
    filters,
    listing,totalCount
  } = useSelector((state) => state.companySlice);
  const {
    listing: planList,
  } = useSelector((state) => state.subscriptionSlice);
  const debouncedSearch = useDebounce(filters.search, 500);

  useEffect(() => {
    const handleCampaignCreated = () => {
      return dispatch(getAllCompanyforListing());
    };
    socket.on(SOCKET_EVENT.COMPANY_CREATED, handleCampaignCreated);
    return () => {
      socket.off(SOCKET_EVENT.COMPANY_CREATED, handleCampaignCreated);
    };
  }, [socket]);

  const handleChangePerPage = (event, value) => {
    dispatch(updateCompany({ limit: event.target.value, page: 0 }));
    dispatch(getAllCompanyforListing());
  };

  const handleChange = (value) => {
    dispatch(updateCompany({ page: value - 1 }));
    dispatch(getAllCompanyforListing());
  };

  const handleRequestSort = (
    event,
    property
  ) => {
    const isAsc = orderBy === property && order === "asc";

    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    dispatch(
      updateCompany({
        sort_type: isAsc ? "asc" : "desc",
        sort_key: property,
      }),
    );
    dispatch(getAllBrandForDropDown());
  };

  useEffect(() => {
    if (debouncedSearch || filters.search == "")
      dispatch(getAllCompanyforListing())
  }, [debouncedSearch]);



  useEffect(() => {
    dispatch(updateSubscription({ limit: 10000 }));
    dispatch(getAllCompanyforListing())
    dispatch(getAllSubscriptions());
    return () => dispatch(resetCompany())
  }, []);

  const handleSearch = (event) => {
    dispatch(updateCompany({ filters: { ...filters, search: event.target.value }, page: 0 }));
  };

  const handleSearchClear = () => {
    dispatch(updateCompany({ filters: { ...filters, search: "" } }));
    dispatch(getAllCompanyforListing());
  };

  return (
    <>
      <Stack direction={"column"} gap={2}>
        <Stack
          className="mainTitle flex-wrap"
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{
            minHeight: '42px', padding: '16px'
          }}
        >
          <Typography className="page-title" variant="h1"> Company Management</Typography>
          <Stack direction="row" justifyContent="flex-end" gap={2} flexWrap="wrap" alignContent="center">

            <button className="btnPrimary"
              disabled={!states?.permissions?.company?.create}
              onClick={() => navigate("/company/add")}>
              Create Company
            </button>
          </Stack>
        </Stack>
        <Stack direction="row" justifyContent="space-between" sx={{ paddingX: '16px' }}>
          <CustomSearchInput
            className="inputSearch sContrl p-0"
            value={filters.search}
            placeholder={"Search here..."}
            handleSearch={handleSearch}
            clearSearch={handleSearchClear}
            startAdornment={START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT}
          />
          <Stack direction="row" justifyContent="flex-end" gap={2} flexWrap="wrap">
            <Select
              sx={{ ...FORM_SELECTFIELD_STYLES, maxHeight: '48px', maxWidth: '250px', width: '250px' }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    borderRadius: "8px",
                    mt: 1,
                  },
                },
              }}
              value={filters.planId || ''}
              name="planId"
              onChange={(e) => {
                dispatch(updateCompany({ filters: { ...filters, planId: e.target.value } }));
                dispatch(getAllCompanyforListing());
              }}
              displayEmpty
              defaultValue={""}
            >
              <MenuItem value="" disabled hidden>
                Current Plan
              </MenuItem>
              <MenuItem value=" " >
                Current Plan (All)
              </MenuItem>
              {planList.map((row) => (
                row.status !== "Draft" && <MenuItem key={row.id} value={row.id}>
                  {row.name}
                </MenuItem>
              ))}
            </Select>
            <Select
              sx={{ ...FORM_SELECTFIELD_STYLES, maxHeight: '48px', maxWidth: '200px', width: '200px' }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    borderRadius: "8px",
                    mt: 1,
                  },
                },
              }}
              value={filters.subscriptionStatus || ''}
              name="planId"
              onChange={(e) => {
                dispatch(updateCompany({ filters: { ...filters, subscriptionStatus: e.target.value } }));
                dispatch(getAllCompanyforListing());
              }}
              displayEmpty
              defaultValue={""}>
              <MenuItem value="" disabled hidden>
                Plan Status
              </MenuItem>
              <MenuItem value=" " >
                Plan Status (All)
              </MenuItem>

              {PLAN_STATUS.map((row) => (
                <MenuItem key={row} value={row}>
                  {row}
                </MenuItem>
              ))}
            </Select>
            <DateRangePickerComponent text="Last Campaign Date" monthsShown={1} getSelectedDate={(dates) => {

              if (dates?.filter((v) => v)?.length === 2) {
                dispatch(updateCompany({ filters: { ...filters, lastCampaignStartdate: getFormatedDate(dates[0]), lastCampaignEnddate: getFormatedDate(dates[1]) } }));
                dispatch(getAllCompanyforListing());
              }

            }} dateReset={filters} style={{ position: "relative", right: 101 }} />
            <DateRangePickerComponent text="Subscription Renewal Date" monthsShown={1} getSelectedDate={(dates) => {
              if (dates?.filter((v) => v)?.length === 2) {
                dispatch(updateCompany({ filters: { ...filters, renewalCampaignStartdate: getFormatedDate(dates[0]), renewalCampaignEnddate: getFormatedDate(dates[1]) } }));
                dispatch(getAllCompanyforListing());
              }

            }} dateReset={filters} style={{ position: "relative", right: 101 }} />

            <Button className="downloadCSV" startIcon={<FileDownloadOutlinedIcon fontSize="small" />} onClick={() => dispatch(getCompanyCSVDowanload())}>Download CSV</Button>
            <Tooltip title="Refresh listing">
              <RotateLeftIcon toolTip="Refresh page" size="small" sx={{ cursor: "pointer", color: '#6C7692', mt: 1.5 }}
                onClick={() => {
                  dispatch(updateCompany({ filters: {} }))
                  dispatch(getAllCompanyforListing());
                }} />
            </Tooltip>
          </Stack>
        </Stack>
        <Box
          sx={{
            backgroundColor: '#fff',
            transition: 'all .5s ease-in-out',
            position: 'relative',
          }}>
          <TableContainer ref={tableRef}>
            <Table
              stickyHeader aria-label="sticky table">
              <EnhancedTableHead
                order={order}
                orderBy={sort_key}
                onRequestSort={handleRequestSort}
                numSelected={0}
                onSelectAllClick={function (

                ) {
                  throw new Error("Function not implemented.");
                }}
              />
              <TableBody >
                {listing && listing?.length ? (
                  listing?.map((row) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row?.id}
                        sx={TABLE_BODY_ROW_MUI_STYLES}>

                        <TableCell component="td" scope="row">
                          <Stack direction={"row"} spacing={2}>
                            <div class="MuiAvatar-root MuiAvatar-circular css-1nn861f-MuiAvatar-root" style={{ display: 'flex', border: '0px solid red', width: 'fit-content', gap: '5px', justifyContent: 'center', alignItems: 'center' }}>
                              <img alt={row?.companyName} style={{ height: '35px', width: '35px', borderRadius: "100px" }} src={row.logo ? row.logo : "/profile.jpg"} className="MuiAvatar-img" />
                            </div>
                            <Link className="text-decoration-none" style={{ fontSize: '13px', fontWeight: '500', letterSpacing: '0px', marginLeft: '8px' }} onClick={(e) => {
                              e.preventDefault();
                              navigate("/company/details/" + row.userId, { state: row })
                            }} >{row?.companyName || "N/A"}</Link>
                          </Stack>
                        </TableCell>
                        <TableCell component="td" scope="row">
                          {row?.contactPersonName || "N/A"}
                        </TableCell>

                        <TableCell align="left">
                          {row?.campaignsRunning || "N/A"}
                        </TableCell>
                        <TableCell align="left">
                          {row?.lastCampaignDate ? getFormatedDate(row?.lastCampaignDate, "MM/DD/YYYY") : "N/A"}

                        </TableCell>
                        <TableCell align="left">
                          {row?.planName || "N/A"}
                        </TableCell>
                        <TableCell align="left">

                          {row?.subscriptionStatus ? <button className={row?.subscriptionStatus?.toLowerCase() + " capitalize-first-letter"}>{row?.subscriptionStatus}</button> : "N/A"}
                        </TableCell>
                        <TableCell align="left">
                          {row?.renewalDate ? getFormatedDate(row?.renewalDate, "MM/DD/YYYY") : "N/A"}
                        </TableCell>
                        <TableCell sx={{ cursor: "pointer" }}>
                          <Stack direction={"row"}
                            sx={{
                              gap: '8px'
                            }}>
                            <div className="actBtnGrps">
                              {states?.permissions?.company?.edit == 1 && <span className="editIcon" onClick={() => navigate(`/company/edit/${row.userId}`, { state: row })}>Edit</span>}
                              <span className="viewIcon" onClick={() => navigate("/company/details/" + row.userId, { state: row })}>View</span>
                            </div>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow colSpan={10}>
                    <TableCell colSpan={10} style={{ textAlign: 'center' }}>

                      <Typography
                        color="inherit"
                        variant="subtitle1"
                        alignItems={"center"}
                        component="h3"
                      >
                        No Data found!
                      </Typography>

                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Stack
            sx={{
              background: 'transparent',
              height: '60px',
              border: '1px solid #E9EAEB'
            }}
            direction="row"
            alignItems={"center"}
            justifyContent={"flex-end"}>
            <CustomPagination
              count={Math.ceil(totalPages / limit) || 0}
              onChange={handleChange}
              currentPage={page}
              handleChangePerPage={handleChangePerPage}
              limit={limit}
              listingCount={listing?.length}
              totalCount={totalCount}
              defaultPage={1} siblingCount={1} boundaryCount={1} />
          </Stack>
          <CommonModel
            open={open}
            handleDialogClose={() => setOpen(false)}
            dialogTitle={"Remove Company"}
            dialogPara={`Are you sure you want to remove this company? `}
            nvYes={"Submit"}
            nvCancel={"Cancel"}
            yesHandle={() => {
              dispatch(deleteCompany(id));
              setOpen(false);
            }}
          />
        </Box>
      </Stack>

    </>
  );
}
